import React from 'react'
import PropTypes from 'prop-types'

import { HBox, Box } from 'app/views/core/Box'

const NavButton = ({ label, kind, active, onClick }) => (
  <button
    className={`uk-button uk-button-small${kind ? ` uk-button-${kind}` : ''}`}
    disabled={!active}
    style={{
      width: '100%',
      height: '100%',
      borderRadius: 10,
    }}
    onClick={onClick}
  >
    {label}
  </button>
)

function StepNavigationButtons(props) {
  const { canNavigateBack, canNavigateForward, canEverFinish, isReadyToFinish } = props
  const { onNavigateBack, onNavigateForward, onAttemptFinish } = props
  return (
    <HBox>
      <Box>
        <NavButton
          label="Previous"
          kind="secondary"
          active={canNavigateBack}
          onClick={() => onNavigateBack()}
        />
      </Box>
      <Box grow />
      <Box>
        {(canEverFinish && !canNavigateForward) ? (
          <NavButton
            label="Finish"
            kind={isReadyToFinish ? 'primary' : ''}
            active={true}
            onClick={() => onAttemptFinish()}
          />
        ) : (
          <NavButton
            label="Next"
            kind="primary"
            active={canNavigateForward}
            onClick={() => onNavigateForward()}
          />
        )}
      </Box>
    </HBox>
  )
}
StepNavigationButtons.propTypes = {
  canNavigateBack: PropTypes.bool.isRequired,
  canNavigateForward: PropTypes.bool.isRequired,
  canEverFinish: PropTypes.bool.isRequired,
  isReadyToFinish: PropTypes.bool.isRequired,
  onNavigateBack: PropTypes.func.isRequired,
  onNavigateForward: PropTypes.func.isRequired,
  onAttemptFinish: PropTypes.func.isRequired,
}

export default StepNavigationButtons
